import { jsx } from '@emotion/core';
import { Overlay } from '../Common';
import { Container, LockIconContainer, Message, Spinner } from './styledComponents';
import { SpinnerLockIcon } from './icons';

var LoadingSpinner = props => jsx(Overlay, {
  containToParent: props.containToParent,
  css: props.overlayStyleOverrides
}, jsx(Container, {
  css: props.containerStyleOverrides,
  "data-testid": props.testId
}, props.withLockIcon && jsx(LockIconContainer, null, jsx(SpinnerLockIcon, {
  title: props.lockIconTitle
})), jsx(Spinner, {
  css: props.spinnerStyleOverrides
}), props.message && jsx(Message, {
  css: props.messageStyleOverrides
}, props.message)));

LoadingSpinner.defaultProps = {
  withLockIcon: true
};
export { LoadingSpinner };